// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: 'efb0ae7',
    builtAt: '2026-08-27T16:28:51.053Z',
} as const;
